<ng-container *ngIf="isNotificationActive">
  <div class="notifier no-select" [class.clickable]="isNotificationClickable()" (click)="onNotificationClick()" [@fadeInExpandOnEnter] [@fadeOutCollapseOnLeave]>
    <p [@displayHide]="isTransitioning ? 'hide' : 'display'">{{ getTranslation() }}</p>
  </div>
</ng-container>